<template>
  <div class="wrapper" :class="[
      { 'nav-open': $sidebar.showSidebar }
    ]">
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>

      <template slot="links">

        <sidebar-item v-if="applicationAccess('USER_MANAGER')" :link="{ name: 'UserManager', path: '/applications/user-manager', icon: 'manage_accounts' }"></sidebar-item>
        
        <sidebar-item  v-if="applicationAccess('ACCU_TEST')" :link="{ name: 'AccuTest', icon: 'check' }">
          <sidebar-item :link="{ name: $lang.menu.test_profile, path: '/applications/accutest/profile' }"></sidebar-item>
          <sidebar-item :link="{ name: $lang.menu.testing_process, path: '/applications/accutest/testing' }"></sidebar-item>
          <sidebar-item :link="{ name: $lang.menu.tests_results, path: '/applications/accutest/results' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item v-if="applicationAccess('REPORT')" :link="{ name: 'Report', icon: 'description' }">
          <sidebar-item :link="{ name: $lang.menu.energy_import, path: '/applications/report/energy/active/import' }"></sidebar-item>
          <sidebar-item :link="{ name: $lang.menu.energy_export, path: '/applications/report/energy/active/export' }"></sidebar-item>
          <sidebar-item :link="{ name: $lang.menu.reactive_energy, path: '/applications/report/energy/reactive' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item v-if="applicationAccess('CONTROLLER')" :link="{ name: 'Controller', icon: 'power_settings_new' }">
          <sidebar-item :link="{ name: $lang.menu.state, path: '/applications/controller/state' }"></sidebar-item>
          <sidebar-item :link="{ name: $lang.menu.disconnector_timeline, path: '/applications/controller/timeline' }"></sidebar-item>
          <sidebar-item :link="{ name: $lang.menu.control_map, path: '/applications/controller/map' }"></sidebar-item>
        </sidebar-item>
        
        

      </template>
    </side-bar>

    <Loader v-show="getLoading"></Loader>

    <div class="main-panel" v-show="!getLoading">
      <top-navbar></top-navbar>

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import Loader from "@/components/Loader";

import TopNavbar from "./TopNavbar";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import UserMenu from "@/pages/Layout/UserMenu.vue";
import ContentFooter from "@/pages/Layout/ContentFooter.vue";

import { ZoomCenterTransition } from "vue2-transitions";
import { addSeconds, format } from "date-fns";
import { handleRedirect } from "@/routes/routes";

import { getUserToken } from "@/storage/memoryStorage";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
    Loader
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true
    };
  },

  computed: {
    notifications() {
      return this.$store.getters.getNotificationList;
    },
    getAuth() {
      return this.$store.getters.getAuth;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    getLoading() {
      return this.$store.getters.getLoading;
    }
  },

  watch: {
    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.type !== oldDevice.type) {
        this.$router.push({
          path: handleRedirect()
        });
      }
    },
    notifications: function() {
      const notificationJSON = this.notifications[0];

      if (notificationJSON.type === "NILM") {
        let notifycationString = "";
        if (notificationJSON.data.event === "ON") {
          notifycationString =
            this.$lang.general.appliance_on +
            "<br>" +
            notificationJSON.data.name +
            "<br>" +
            this.$lang.charts.phase +
            " " +
            notificationJSON.data.phase +
            "<br>" +
            this.$lang.general.identification_success +
            " " +
            Number(notificationJSON.data.prediction_rate).toFixed(1) +
            " %";
        } else if (notificationJSON.data.event === "OFF") {
          const helperDate = addSeconds(
            new Date(0),
            notificationJSON.data.runtime
          );
          const durationString = format(
            helperDate,
            "m [" +
              this.$lang.general.minutes +
              "] [" +
              this.$lang.general.and +
              "] s [" +
              this.$lang.general.seconds +
              "]"
          );

          notifycationString =
            this.$lang.general.appliance_off +
            "<br>" +
            notificationJSON.data.name +
            "<br>" +
            this.$lang.charts.phase +
            " " +
            notificationJSON.data.phase +
            "<br>" +
            this.$lang.general.duration +
            " " +
            durationString +
            "<br>" +
            this.$lang.general.energy_consumption +
            " " +
            Number(notificationJSON.data.energy_consumption_wh).toFixed(1) +
            " Wh" +
            "<br>" +
            this.$lang.general.identification_success +
            " " +
            Number(notificationJSON.data.prediction_rate).toFixed(1) +
            " %";
        }
        this.showNotification(notifycationString);
      }
    }
  },

  methods: {
    applicationAccess(application) {
      if (this.getAuth.applications.findIndex(app => app === application) != -1) {
        return true;
      }
      return false;
    },

    showNotification: function(msg) {
      this.$notify({
        message: msg,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "info"
      });
    },

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  }
};
</script>

<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.main-panel > .content {
  padding: 0px 15px;
}

.charts {
  min-height: 500px;
  height: 70vh;
}
</style>
